import React from 'react';
import ReactDOM from 'react-dom/client';
import "./style/main.css"
import Entrypoint from './Entrypoint';
import {I18nextProvider} from "react-i18next";
import i18n from "./handlers/i18n";
import {SessionProvider} from "./auth/SessionContext";
import ToastProvider from "./components/custom/toasters/ToastersManager";

if (process.env.NODE_ENV === 'production') {
	console.debug = () => {
	}; // Disable debug logging in production
}

const root = ReactDOM.createRoot(
		document.getElementById('root') as HTMLElement
);

// used to accept directories in the cd-upload page
declare module "react" {
	interface InputHTMLAttributes<T> extends HTMLAttributes<T> {
		webkitdirectory?: string;
	}
}

declare global {
	interface Window {
		// google apis for google sign-in.
		// unfortunately there isn't any type that we can use for now for this
		// since they are available only for the previous version of the sign-in apis.
		google: any;
	}
}

root.render(
		<I18nextProvider i18n={i18n}>
			<ToastProvider>
				<SessionProvider>
					<Entrypoint/>
				</SessionProvider>
			</ToastProvider>
		</I18nextProvider>
);
